import { CUSTOM_SECTION_UPDATE_FORM_GENERATOR } from '../../../../supplementary_components/itemEditMethods';
import { API_ROOT } from '../../../../supplementary_components/requests';
import cloneDeep from 'lodash/cloneDeep';
import { invalidActionBasedOnTypeAndDesc, TypeToTitle } from './listOfActions';
import { DateTime } from "luxon";
import { Form } from '../../../forms/Form';
import { addPopup } from '../../../../supplementary_components/store';

export const AddOrEditCustomTask = (taskList, setTasks, truckId, atIndex, currentTask, taskWithDuration) => {

    
    const columns = ()=>{
        return [
            {
                notInAddForm:true,
                name: "tasks",
                type: 'taskList',
                taskWithDuration: taskWithDuration,
                newTask: [currentTask],
                processChanges: (column, data)=>{
                    const form = document.querySelector('#newTaskAddingForm');
                    let taskCopy = cloneDeep(column.newTask[0]);
                    let invalidTask = taskCopy === null ? true : false;
                    let actionType = false;
                    try {
                        if(!invalidTask){
                            actionType = taskCopy.actions[0].type
                        }
                    } catch (error) {
                    }
                    const checkResult = checkAndMarkForInvalidFields(form, actionType, taskCopy?.actions[0]);
                    if(checkResult.dismissWithCustomMsg){
                        return checkResult;
                    }else if(checkResult.invalidInput){
                        return null;
                    }else if(checkResult.newType ){
                        try {
                            if(invalidTask){
                                taskCopy = {};
                            }
                            if(actionType === 'reset' || actionType === 'homeTime'){
                                if(checkResult.apptDate){
                                    taskCopy.apptDate = checkResult.apptDate;
                                    
                                }
                                if(checkResult.apptTime !== undefined){
                                    taskCopy.apptTime = checkResult.apptTime || null;
                                }
                                
                            }
                            taskCopy["actions"] = [{
                                "loadAction" : false,
                                "dispatched": false,
                                "dispatchingRequired": true,
                                "title": TypeToTitle(checkResult.newType),
                                "type": checkResult.newType,
                                "desc": checkResult.newDesc,
                                "completed": false}];
                            
                            if(checkResult.newDuration){
                                taskCopy.actions[0].durationInDays = checkResult.newDuration;
                            }
                            if(checkResult.endDate){
                                taskCopy.actions[0].endDate = checkResult.endDate;
                            }
                            if(checkResult.endTime){
                                taskCopy.actions[0].endTime = checkResult.endTime;
                            }
                            if(checkResult.endingTimeType){
                                taskCopy.actions[0].endingTimeType = checkResult.endingTimeType;
                                if(checkResult.endingTimeType === "Until"){
                                    delete taskCopy.actions[0].durationInDays;
                                }else if(checkResult.endingTimeType === "Plus"){
                                    delete taskCopy.actions[0].endDate;
                                    delete taskCopy.actions[0].endTime;
                                }
                            }
                            
                            
                            
                            invalidTask = false;
                            actionType = checkResult.newType;
                        } catch (error) {
                            
                        }
                        
                    }
                    if(invalidTask || !actionType)return null;

                    
                   
                    if(actionType !== "reset" && actionType !== "homeTime"){
                        let apptTime = form?.querySelector('#apptTime')?.value ?? "";
                        let apptDate = form?.querySelector('#apptDate')?.value ?? "";
                        taskCopy.apptTime = apptTime === '' ? null : apptTime ;
                        taskCopy.apptDate = apptDate === '' ? null : apptDate ;
                    }
                    

                    if(actionType === 'reset'){
                        const firstAction = taskCopy.actions[0];
                        if(taskCopy.apptTime && taskCopy.apptDate && (firstAction.durationInDays || (firstAction.endDate && firstAction.endTime))){
                            firstAction.resetEndETA = dateTimeToResetEndString(taskCopy.apptDate, taskCopy.apptTime, firstAction.durationInDays, firstAction.endDate, firstAction.endTime);
                        }else{
                            delete firstAction.resetEndETA;
                        }
                    }
                    
                    try {
                        delete taskCopy.address.apptTime;
                        delete taskCopy.address.apptDate;
                        delete taskCopy.address.stopOrderNumber;
                        delete taskCopy.address.stopTypeStatic;
                        delete taskCopy.address.suggestionsList;
                    } catch (error) {
                    }
                    if(taskCopy.zonedDateTime === "")taskCopy.zonedDateTime = null;
                    return taskCopy;
                }
            }
        ]
    }
    const updateTasks = (task) => {
                
        try {
            // task.actions = JSON.parse(task.actions);
            const taskListCopy = taskList ? [...taskList] : [];
            if(currentTask){
                for(let i = 0; i<taskListCopy.length; i++){
                    if(taskListCopy[i].id === task.id){
                        taskListCopy[i] = task;
                    }
                }
            }else{
                if(taskListCopy.length > 0){
                    taskListCopy.splice(atIndex, 0, task);
                }else{
                    taskListCopy.push(task)
                }
            }
            setTasks(taskListCopy);
        } catch (error) {
            console.log(error);
            
        }
        
    }
    const link = currentTask ? `${API_ROOT}trucks/editTask/${truckId}` : `${API_ROOT}trucks/addTask/${truckId}?index=${atIndex}`
    CUSTOM_SECTION_UPDATE_FORM_GENERATOR("Add New Task", link, currentTask?"Update Task":"Add Task", "Task Added", columns, updateTasks, false);
}
export const AddNewTaskMethod = (taskList, setTasks, truckId, atIndex, currentTask) => {
    if(currentTask){
        const firstActionType = currentTask?.actions[0]?.type ?? "";
        AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask, (firstActionType === "homeTime" || firstActionType === "reset"));
    }else{
        addPopup({content:Form, popupData:{configuration: {
            formTitle: "Add Task",
            oneButtonMode: true,
            selectMode: true,
            options: [
                {
                    label: "Home Time / Reset",
                    action: () => {
                        AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask, true);
                    },
                },
                {
                    label: "Custom Task",
                    action: () => {
                        AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask);
                    },
                },
            ]
        }}, postSuccessAction: ()=>{}, EZCloseAllowed:true})
    }
    
    
}
// case "shop":
// case "puTrailer":
// case "dropTrailer":
// case "swapTrailer": (no address required)
// case "yard":
// case "park": (City And State)
// case "homeTime": (no address required)
// case "custom": (no address required)
// const fullAddressRequired = 
// const cityAndStateOnly = ['city', 'state']
const fulladdressFields = ['companyName', 'city', 'state', 'postalCode'];
const resetRequiredFileds = ['apptDate', 'apptTime', 'endDate', 'endTime', "durationInDays"];
const homeTimeRequiredFileds = ['apptDate', 'endDate', "durationInDays", "city", 'state'];
const checkAndMarkForInvalidFields = (formTag, actionType, firstAction) => {        
    let invalidInputFound = false;
    let mandatoryFieldNames = [];
    let newTypeObtained = false;
    let newDesc = null;
    let newDuration = null;
    if(!formTag.nextSibling){ // Reset OR Home Time Action
        const container = document.querySelector('#resetOrHomeTimeContainer').parentElement;
        
        if(actionType){
            const array = actionType === "reset" ? resetRequiredFileds : homeTimeRequiredFileds;
            const response = {}
            container.querySelectorAll('input').forEach(input => {
                
                if(array.includes(input.name) && input.value === ''){
                    addErrorClass(input);
                    invalidInputFound = true;
                }
            });


            response.invalidInput = invalidInputFound;
            if(!invalidInputFound){
                if(firstAction.endingTimeType === "Until"){
                    const start = DateTime.fromFormat(`${firstAction.apptDate} ${firstAction.apptTime || "00:00 AM"}`, "MM/dd/yy hh:mm a");
                    const end = DateTime.fromFormat(`${firstAction.endDate} ${firstAction.endTime || "00:00 AM"}`, "MM/dd/yy hh:mm a");
                    if(start.valueOf() >= end.valueOf()){
                        addErrorClass(container.querySelector(`input[name="apptDate"]`));
                        if(firstAction.apptTime){
                            addErrorClass(container.querySelector(`input[name="apptTime"]`));
                        }
                        return {dismissWithCustomMsg:true, customMsg:"Start time cannot be after end time"}
                    }
                }
                response.newType = actionType;
                response.apptDate = firstAction.apptDate;
                response.apptTime = firstAction.apptTime;
                response.endDate = firstAction.endDate;
                response.endTime = firstAction.endTime;
                response.endingTimeType = firstAction.endingTimeType
                response.newDesc = firstAction.desc
                response.newDuration = parseInt(firstAction.durationInDays);
            }
            return response;
        }else{
            container.querySelectorAll('input').forEach(input => {
                if(resetRequiredFileds.includes(input.name) && input.value === ''){
                    addErrorClass(input);
                }
            });
            return {invalidInput: true}
        }
        
    }if(!actionType){
        
        const tag = formTag.nextSibling.querySelector('.actionBox');
        try {
            
            const type = tag.querySelector('#actionsType').value;
            const desc = tag.querySelector('#actionsDescription').value;                        
            const duration = tag.querySelector('#durationInDays').value;                        
            if(invalidActionBasedOnTypeAndDesc(type, desc)){
                invalidInputFound = true;
                addErrorClass(tag);
            }else{
                newDuration = duration !== '' ? parseInt(duration) : null;
                newTypeObtained = true;
                actionType = type;
                newDesc = desc !== '' ? desc : null;
            }
        } catch (error) {
        }
    }
    
    if(actionType){
        if(actionType === "shop" || actionType === "puTrailer" || actionType === "dropTrailer" || actionType === "yard"){
            mandatoryFieldNames = fulladdressFields;
        }else if (actionType === "park"){
            mandatoryFieldNames = ['city', 'state'];
        }
    }
    
    for(let name of mandatoryFieldNames){
        const tag = formTag.querySelector(`input[name="${name}"]`);
        if (tag.value.trim() === ''){
            invalidInputFound = true;
            addErrorClass(tag);
        }
    }
    const response = {
        invalidInput: invalidInputFound
    }
    if(newTypeObtained){
        response.newType = actionType;
        response.newDesc = newDesc;
        if(newDuration){
            response.newDuration = newDuration;
        }
    }
    
    return response;
}
export function dateTimeToResetEndString(apptDate, apptTime, durationInHours, endDate, endTime){
    try {
        if(durationInHours){
            return DateTime.fromFormat(
                `${apptDate} ${apptTime}`,
                "MM/dd/yy hh:mm a",
                { zone: localStorage.getItem("defaultTimezone"), locale: "en-US" }
            ).plus({ hours: durationInHours}).toFormat("MM/dd hh:mm a");
        }else if(endDate && endTime){
            return DateTime.fromFormat(
                `${endDate} ${endTime}`,
                "MM/dd/yy hh:mm a",
                { zone: localStorage.getItem("defaultTimezone"), locale: "en-US" }
            ).toFormat("MM/dd hh:mm a");
        }
        
    } catch (error) {
        return null;
    }
}
function addErrorClass(tag){
    if(tag && !tag.className.includes('subError')){
        tag.classList += ' subError';
    }
}